<template>
  <div>
    <div class="DataTable">
      <v-form ref="form1" lazy-validation>
        <v-layout column>
          <v-flex style="overflow: auto">
            <v-data-table
              item-key="documentNumber"
              :headers="headers_modal_izabrani_tankovi"
              :items="items_modal_izabrani_tankovi"
              hide-actions
              class="elevation-1"
              show-select
              dense
              :pagination.sync="pagination"
            >
              <template slot="headers" slot-scope="props_modal">
                <tr>
                  <!-- <th style="text-align: center; padding: 5px">
                      
                    </th> -->
                  <th
                    style="text-align: center"
                    v-for="header in props_modal.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                      header.align === 'left'
                        ? 'text-xs-left'
                        : 'text-xs-center',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props_modal">
                <tr>
                  <td style="text-align: center; padding: 5px">
                    {{ props_modal.item.documentNumber }}
                  </td>
                  <td style="text-align: center; padding: 5px">
                    {{ props_modal.item.warehouseName }}
                  </td>
                  <td style="text-align: center; padding: 5px">
                    {{ props_modal.item.lot }}
                  </td>
                  <td
                    style="text-align: center; padding: 5px"
                    v-if="props_modal.item.validToDate !== null"
                  >
                    {{ formatDateTime(props_modal.item.validToDate) }}
                  </td>
                  <td style="text-align: center; padding: 5px" v-else>
                    {{ "-" }}
                  </td>
                  <td style="text-align: center; padding: 5px">
                    {{
                      parseFloat(props_modal.item.restedQuantity).toFixed(
                        brojDecOstatak
                      ) +
                      " " +
                      props_modal.item.unitOfMeasure.mark.replace("psc", "kom")
                    }}
                  </td>
                  <td style="text-align: right; padding-right: 0px" v-if="edit">
                    <v-edit-dialog
                      @save="cancel(props_modal)"
                      @cancel="save(props_modal)"
                      @close="close(props_modal)"
                      @open="open(props_modal.item.quantity)"
                      lazy
                      large
                      cancel-text="OK"
                      save-text="Odustani"
                      style="padding-left: 20px"
                    >
                      <!-- v-model="props_modal.item.quantity"
                    onkeyup="if(this.value > 1000) alert('Vrednost ne može biti veća od 1000.');"
                     -->
                      <template v-slot:input>
                        <v-text-field
                          v-model="props_modal.item.quantity"
                          v-bind:value="props_modal.item.quantity"
                          slot="input"
                          single-line
                          type="number"
                          :suffix="pomUnitOfMeasureMark"
                          ref="kolicina"
                        ></v-text-field>
                      </template>
                      {{
                        parseFloat(props_modal.item.quantity).toFixed(brojDec) +
                        " " +
                        pomUnitOfMeasureMark
                      }}
                    </v-edit-dialog>
                  </td>
                  <td style="text-align: center; padding: 15px" v-else>
                    {{
                      parseFloat(props_modal.item.quantity).toFixed(brojDec) +
                      " " +
                      pomUnitOfMeasureMark
                    }}
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="primary"
                  icon="info"
                  >Nema podataka.</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn @click="submit" class="AppButtonFilled" :disabled="!edit"
              >Sačuvaj</v-btn
            >
            <v-btn @click="clear" class="AppButtonOutlined" v-if="edit"
              >odustani</v-btn
            >
            <v-btn
              @click="clear"
              class="AppButtonOutlined"
              :disabled="!edit"
              v-else
              style="border: none !important"
              >odustani</v-btn
            >
          </v-flex>
        </v-layout>
      </v-form>
    </div>
  </div>
</template>

        <script>
import { readJSON } from "../helpers/Functions";

export default {
  props: [
    "articleId",
    "documentId",
    "operation",
    "unitOfMeasureId",
    "additiveQuantity",
    "ID",
    "izabrani_aditiv",
    "dodavanje_novog",
    "listaMaterijalaMaka",
    "edit",
  ],
  name: "myform",
  methods: {
    formatDateTime(date) {
      let lokDate = date.split("T")[0];
      let lokTime = date.split("T")[1];

      let month = lokDate.split("-")[1];
      let day = lokDate.split("-")[2];
      const year = lokDate.split("-")[0];

      let HH = lokTime.split(":")[0];
      let mm = lokTime.split(":")[1];

      return [day, month, year].join(".") + " " + [HH, mm].join(":");
    },
    submit() {
      let sum = 0;
      let _this = this;

      this.items_modal_izabrani_tankovi.forEach(function (element) {
        sum = sum + Number(element.quantity);

        if (Number(element.quantity) !== 0) {
          let complexObject;

          let ind = -1;

          if (_this.documentId !== 0) {
            if (Number(element.id) !== 0)
              complexObject = {
                id: element.id,
                materialOperationId: _this.documentId,
                operation: _this.operation,
                warehouseInputOutputItem: {
                  id: element.itemId,
                },
                quantity: element.quantity,
                unitOfMeasure: {
                  id: _this.pomUnitOfMeasureId,
                },
              };
            else
              complexObject = {
                materialOperationId: _this.documentId,
                operation: _this.operation,
                warehouseInputOutputItem: {
                  id: element.itemId,
                },
                quantity: element.quantity,
                unitOfMeasure: {
                  id: _this.pomUnitOfMeasureId,
                },
              };

            ind = _this.materialFromWarehouseDocumentItemList.findIndex(
              (x) =>
                x.warehouseInputOutputItem.id ===
                complexObject.warehouseInputOutputItem.id
            );

            if (ind >= 0) {
              _this.materialFromWarehouseDocumentItemList.splice(ind, 1);
            }
          } else {
            complexObject = {
              materialOperationId: _this.documentId,
              operation: _this.operation,
              warehouseInputOutputItem: {
                id: element.itemId,
              },
              quantity: element.quantity,
              unitOfMeasure: {
                id: _this.pomUnitOfMeasureId,
              },
            };

            ind = _this.materialFromWarehouseDocumentItemList.findIndex(
              (x) =>
                x.warehouseInputOutputItem.id ===
                complexObject.warehouseInputOutputItem.id
            );

            if (ind >= 0) {
              _this.materialFromWarehouseDocumentItemList.splice(ind, 1);
            }
          }
          _this.materialFromWarehouseDocumentItemList.push(complexObject);
        }
      });

      if (
        parseFloat(sum).toFixed(this.brojDec) !==
        parseFloat(this.additiveQuantity).toFixed(this.brojDec)
      ) {
        if (
          confirm(
            "Količina repromaterijala je različita od izabranih po izdatnicama. Da li želite da potvrdite količinu repromaterija?"
          )
        ) {
          if (
            this.items_modal_izabrani_tankovi.length > 0 &&
            this.documentId > 0
          )
            this.changeMaterialDocument();
          else
            this.$emit("newdata", this.materialFromWarehouseDocumentItemList);
        }
      } else {
        if (this.items_modal_izabrani_tankovi.length > 0 && this.documentId > 0)
          this.changeMaterialDocument();
        else this.$emit("newdata", this.materialFromWarehouseDocumentItemList);
      }
    },
    clear() {
      this.getAllSifarnik2();
    },
    getAllSifarnik2() {
      let _this = this;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/material_from_document/" +
            this.articleId +
            "/unused",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let newArray = [];

          newArray = response.data;
          

          newArray.forEach(function (e) {
              if (typeof e === "object") {
                e["quantity"] = 0;
                e["id"] = 0;
                e["quantityPom"] = 0;
              }
            });

          
            

          let pomObjekat;

          if (_this.izabrani_aditiv !== undefined)
            _this.izabrani_aditiv.forEach(function (e1) {
              e1.materialFromWarehouseDocumentItems.forEach(function (e) {
                if (
                  e.warehouseInputOutputItem.warehouseInputOutputDocNumber !==
                    undefined &&
                  e.warehouseInputOutputItem.warehouseInputOutputDocNumber !==
                    null
                ) {
                  pomObjekat = {
                    itemId: e.warehouseInputOutputItem.id,
                    documentNumber:
                      e.warehouseInputOutputItem.warehouseInputOutputDocNumber,
                    warehouseName: e.warehouseInputOutputItem.warehouse,
                    lot: e.warehouseInputOutputItem.lot,
                    unitOfMeasure: e.unitOfMeasure,
                    restedQuantity: e.quantity,
                    id: e.id,
                    quantity: e.quantity,
                    quantityPom: e.quantity,
                    validToDate: null,
                  };

                  let ind = 0;
                  ind = newArray.findIndex(
                    (x) =>
                      x.documentNumber ===
                        e.warehouseInputOutputItem
                          .warehouseInputOutputDocNumber &&
                      x.lot === e.warehouseInputOutputItem.lot
                  );

                  if (ind < 0) {
                    newArray.push(pomObjekat);

                    
                  }
                  else {
                    newArray[ind].id = e.id;
                    newArray[ind].quantity = e.quantity;
                    newArray[ind].quantityPom = e.quantity;
                  }
                }
              });
            });

            if (newArray.length === 1) {
                      newArray[0].id = 0;
                      newArray[0].quantity = Number(_this.additiveQuantity);
                      newArray[0].quantityPom = Number(_this.additiveQuantity);
                    }
                    
          _this.items_modal_izabrani_tankovi = newArray;

          if (_this.izabrani_aditiv !== undefined)
            if (_this.izabrani_aditiv.length > 0)
              _this.items_modal_izabrani_tankovi.forEach(function (element) {
                _this.izabrani_aditiv.forEach(function (elem1) {
                  if (elem1.materialFromWarehouseDocumentItems !== undefined) {
                    elem1.materialFromWarehouseDocumentItems.forEach(function (
                      elem
                    ) {
                      if (element.itemId === elem.warehouseInputOutputItem.id) {
                        element.id = elem.id;

                        element.quantity = Number(elem.quantity);
                        element.quantityPom = Number(elem.quantity);
                      }
                    });
                  } else if (element.itemId === elem1.id) {
                    if (_this.additiveQuantity !== undefined) {
                      element.quantity = Number(_this.additiveQuantity);
                      element.quantityPom = Number(_this.additiveQuantity);
                    } else {
                      element.quantity = 0;
                      element.quantityPom = 0;
                    }
                  } else if (elem1.warehouseInputOutputItem !== undefined)
                    if (element.itemId === elem1.warehouseInputOutputItem.id) {
                      if (_this.additiveQuantity !== undefined) {
                        element.quantity = Number(_this.additiveQuantity);
                        element.quantityPom = Number(_this.additiveQuantity);
                      } else {
                        element.quantity = 0;
                        element.quantityPom = 0;
                      }
                    }
                });
              });
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/material_from_document/" +
                        this.articleId +
                        "/unused",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let newArray = [];

                      newArray = response.data;
                      if (newArray.length === 1) {
                        newArray[0].id = 0;
                        newArray[0].quantity = Number(_this.additiveQuantity);
                        newArray[0].quantityPom = Number(
                          _this.additiveQuantity
                        );
                      } else
                        newArray.forEach(function (e) {
                          if (typeof e === "object") {
                            e["quantity"] = 0;
                            e["id"] = 0;
                            e["quantityPom"] = 0;
                          }
                        });

                      let pomObjekat;

                      if (_this.izabrani_aditiv !== undefined)
                        _this.izabrani_aditiv.forEach(function (e1) {
                          e1.materialFromWarehouseDocumentItems.forEach(
                            function (e) {
                              if (
                                e.warehouseInputOutputItem
                                  .warehouseInputOutputDocNumber !==
                                  undefined &&
                                e.warehouseInputOutputItem
                                  .warehouseInputOutputDocNumber !== null
                              ) {
                                pomObjekat = {
                                  itemId: e.warehouseInputOutputItem.id,
                                  documentNumber:
                                    e.warehouseInputOutputItem
                                      .warehouseInputOutputDocNumber,
                                  warehouseName:
                                    e.warehouseInputOutputItem.warehouse,
                                  lot: e.warehouseInputOutputItem.lot,
                                  unitOfMeasure: e.unitOfMeasure,
                                  restedQuantity: e.quantity,
                                  id: e.id,
                                  quantity: e.quantity,
                                  quantityPom: e.quantity,
                                  validToDate: null,
                                };

                                let ind = 0;
                                ind = newArray.findIndex(
                                  (x) =>
                                    x.documentNumber ===
                                      e.warehouseInputOutputItem
                                        .warehouseInputOutputDocNumber &&
                                    x.lot === e.warehouseInputOutputItem.lot
                                );

                                if (ind < 0) newArray.push(pomObjekat);
                                else {
                                  newArray[ind].id = e.id;
                                  newArray[ind].quantity = e.quantity;
                                  newArray[ind].quantityPom = e.quantity;
                                }
                              }
                            }
                          );
                        });

                      _this.items_modal_izabrani_tankovi = newArray;

                      if (_this.izabrani_aditiv !== undefined)
                        if (_this.izabrani_aditiv.length > 0)
                          _this.items_modal_izabrani_tankovi.forEach(function (
                            element
                          ) {
                            _this.izabrani_aditiv.forEach(function (elem1) {
                              if (
                                elem1.materialFromWarehouseDocumentItems !==
                                undefined
                              ) {
                                elem1.materialFromWarehouseDocumentItems.forEach(
                                  function (elem) {
                                    if (
                                      element.itemId ===
                                      elem.warehouseInputOutputItem.id
                                    ) {
                                      element.id = elem.id;

                                      element.quantity = Number(elem.quantity);
                                      element.quantityPom = Number(
                                        elem.quantity
                                      );
                                    }
                                  }
                                );
                              } else if (element.itemId === elem1.id) {
                                if (_this.additiveQuantity !== undefined) {
                                  element.quantity = Number(
                                    _this.additiveQuantity
                                  );
                                  element.quantityPom = Number(
                                    _this.additiveQuantity
                                  );
                                } else {
                                  element.quantity = 0;
                                  element.quantityPom = 0;
                                }
                              } else if (
                                elem1.warehouseInputOutputItem !== undefined
                              )
                                if (
                                  element.itemId ===
                                  elem1.warehouseInputOutputItem.id
                                ) {
                                  if (_this.additiveQuantity !== undefined) {
                                    element.quantity = Number(
                                      _this.additiveQuantity
                                    );
                                    element.quantityPom = Number(
                                      _this.additiveQuantity
                                    );
                                  } else {
                                    element.quantity = 0;
                                    element.quantityPom = 0;
                                  }
                                }
                            });
                          });
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getUnitOfMeasureId() {
      let pomocniUnitOfMeasureId = 0;

      if (this.unitOfMeasureId.id === undefined)
        pomocniUnitOfMeasureId = this.unitOfMeasureId;
      else pomocniUnitOfMeasureId = this.unitOfMeasureId.id;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/add/absolute_aditive_unit_of_measure/" +
            pomocniUnitOfMeasureId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.pomUnitOfMeasureId = response.data.id;
          this.pomUnitOfMeasureMark = response.data.mark;

          if (this.pomUnitOfMeasureMark === "psc")
            this.pomUnitOfMeasureMark = "kom";

          

          if (
            this.pomUnitOfMeasureMark === "kom" &&
            this.operation !== "ADDING"
          )
            this.brojDecOstatak = 0;
          else if (this.pomUnitOfMeasureMark === "kom") this.brojDecOstatak = 1;
          else this.brojDecOstatak = 4;

          if (
            this.pomUnitOfMeasureMark === "kom" &&
            this.operation !== "ADDING"
          )
            this.brojDec = 0;
          else if (
            this.pomUnitOfMeasureMark === "g" ||
            this.pomUnitOfMeasureMark === "ml" ||
            this.pomUnitOfMeasureMark === "kom"
          )
            this.brojDec = 1;
          else this.brojDec = 4;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/add/absolute_aditive_unit_of_measure/" +
                        pomocniUnitOfMeasureId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.pomUnitOfMeasureId = response.data.id;
                      this.pomUnitOfMeasureMark = response.data.mark;

                      if (
                        this.pomUnitOfMeasureMark === "kom" &&
                        this.operation !== "ADDING"
                      )
                        this.brojDecOstatak = 0;
                      else if (this.pomUnitOfMeasureMark === "kom")
                        this.brojDecOstatak = 1;
                      else this.brojDecOstatak = 4;

                      if (
                        this.pomUnitOfMeasureMark === "kom" &&
                        this.operation !== "ADDING"
                      )
                        this.brojDec = 0;
                      else if (
                        this.pomUnitOfMeasureMark === "g" ||
                        this.pomUnitOfMeasureMark === "ml" ||
                        this.pomUnitOfMeasureMark === "kom"
                      )
                        this.brojDec = 1;
                      else this.brojDec = 4;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnikUsed() {
      if (this.documentId != undefined && this.documentId != 0) {
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/material_from_document/" +
              this.documentId +
              "/" +
              this.operation,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            let newArray = response.data;
            let _this = this;

            newArray.forEach(function (e) {
              if (typeof e === "object") {
                let complexObject;
                complexObject = {
                  documentId: null,
                  documentNumber: e.documentNumber,
                  id: e.id,
                  lot: e.lot,
                  productionDate: e.productionDate,
                  quantity: e.quantity,
                  quantityPom: e.quantity,
                  restedQuantity: e.restedQuantity,
                  unitOfMeasure: e.restedUnitOfMeasure,
                  validToDate: e.validToDate,
                  warehouseName: e.warehouseName,
                  lot: e.lot,
                  itemId: e.warehouseInputOutputItem.id,
                };

                let ind = 0;
                ind = _this.items_modal_izabrani_tankovi.findIndex(
                  (x) => x.itemId === e.warehouseInputOutputItem.id
                );

                if (ind >= 0) {
                  _this.items_modal_izabrani_tankovi.splice(ind, 1);
                }

                _this.items_modal_izabrani_tankovi.push(complexObject);
              }
            });
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/material_from_document/" +
                          this.documentId +
                          "/" +
                          this.operation,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        let newArray = response.data;
                        let _this = this;

                        newArray.forEach(function (e) {
                          if (typeof e === "object") {
                            let complexObject;

                            complexObject = {
                              documentId: null,
                              documentNumber: e.documentNumber,
                              id: e.id,
                              lot: e.lot,
                              productionDate: e.productionDate,
                              quantity: e.quantity,
                              quantityPom: e.quantity,
                              restedQuantity: e.restedQuantity,
                              unitOfMeasure: e.restedUnitOfMeasure,
                              validToDate: e.validToDate,
                              warehouseName: e.warehouseName,
                              lot: e.lot,
                              itemId: e.warehouseInputOutputItem.id,
                            };

                            let ind = 0;
                            ind = _this.items_modal_izabrani_tankovi.findIndex(
                              (x) => x.itemId === e.warehouseInputOutputItem.id
                            );

                            if (ind >= 0) {
                              _this.items_modal_izabrani_tankovi.splice(ind, 1);
                            }

                            _this.items_modal_izabrani_tankovi.push(
                              complexObject
                            );
                          }
                        });
                      })
                      .catch((e) => {
                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    close(e) {
      e.item.quantity = this.pomQuantity;
    },
    open(e) {
      this.pomQuantity = e;

      setTimeout(() => {
        let inputEl = this.$refs.kolicina.$el.querySelector("input");
        inputEl.select();
      }, 200);
    },
    cancel(e) {
      e.item.quantity = this.pomQuantity;
    },
    save(e) {
      if (e.item.quantity !== "") {
        let ind = -1;
        ind = this.materialFromWarehouseDocumentItemList.findIndex(
          (x) => x.warehouseInputOutputItem.id === e.item.itemId
        );

        let pomQuantityLoc = 0;

        if (
          e.item.unitOfMeasure.mark === "kg" ||
          e.item.unitOfMeasure.mark === "l"
        )
          pomQuantityLoc = 1000 * e.item.restedQuantity;
        else pomQuantityLoc = e.item.restedQuantity;

        let restQuantityLoc = 0;
        let indPom = 0;
        indPom = this.items_modal_izabrani_tankovi.findIndex(
          (x) => x.id === e.item.id && x.itemId === e.item.itemId
        );

        restQuantityLoc = this.items_modal_izabrani_tankovi[indPom].quantityPom;

        if (pomQuantityLoc !== 0) {
          let complexObject;

          if (e.item.id === 0 || this.documentId === 0) {
            if (this.documentId === undefined)
              complexObject = {
                warehouseInputOutputItem: {
                  id: e.item.itemId,
                },
                materialOperationId: null,
                quantity: e.item.quantity,
                operation: this.operation,
                unitOfMeasure: {
                  id: this.pomUnitOfMeasureId,
                },
              };
            else
              complexObject = {
                warehouseInputOutputItem: {
                  id: e.item.itemId,
                },
                materialOperationId: this.documentId,
                quantity: e.item.quantity,
                operation: this.operation,
                unitOfMeasure: {
                  id: this.pomUnitOfMeasureId,
                },
              };
          } else {
            if (this.documentId === undefined)
              complexObject = {
                id: e.item.id,
                materialOperationId: null,
                operation: this.operation,
                warehouseInputOutputItem: {
                  id: e.item.itemId,
                },
                quantity: e.item.quantity,
                unitOfMeasure: {
                  id: this.pomUnitOfMeasureId,
                },
              };
            else
              complexObject = {
                id: e.item.id,
                materialOperationId: this.documentId,
                operation: this.operation,
                warehouseInputOutputItem: {
                  id: e.item.itemId,
                },
                quantity: e.item.quantity,
                unitOfMeasure: {
                  id: this.pomUnitOfMeasureId,
                },
              };
          }

          if (ind >= 0) {
            this.materialFromWarehouseDocumentItemList.splice(ind, 1);
          }

          // if(Number(e.item.quantity) !== 0)
          this.materialFromWarehouseDocumentItemList.push(complexObject);
        }

        this.open(e.item.quantity);
      }
    },
    changeMaterialDocument() {
      // console.log(JSON.stringify(complexObject));

      let pomNiz = [];
      let _this = this;

      this.materialFromWarehouseDocumentItemList.forEach(function (element) {
        // if (
        //   _this.pomUnitOfMeasureMark === "g" ||
        //   _this.pomUnitOfMeasureMark === "ml"
        // ) {
        //   element.quantity = element.quantity / 1000;
        // }

        pomNiz.push(element);
      });

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/material_from_document",
          pomNiz,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let pomNiz = [];

          this.materialFromWarehouseDocumentItemList.forEach(function (
            element
          ) {
            if (Number(element.quantity) !== 0) {
              pomNiz.push(element);
            }
          });

          this.$emit("newdata", pomNiz);

          this.getAllSifarnik2();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/material_from_document",
                      pomNiz,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let pomNiz = [];

                      this.materialFromWarehouseDocumentItemList.forEach(
                        function (element) {
                          if (Number(element.quantity) !== 0) {
                            pomNiz.push(element);
                          }
                        }
                      );

                      this.$emit("newdata", pomNiz);

                      this.getAllSifarnik2();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },

  data: () => ({
    materialFromWarehouseDocumentItemList: [],
    pagination: {
      sortBy: "id",
      rowsPerPage: 10000000,
    },
    headers_modal_izabrani_tankovi: [
      { text: "Broj dokumenta", value: "documentNumber", align: "left" },
      { text: "Magacin", value: "warehouseName", align: "left" },
      { text: "Lot", value: "lot", align: "left" },
      { text: "Datum važenja", value: "validToDate", align: "left" },
      { text: "Neiskorišćeno", value: "restedQuantity", align: "left" },
      { text: "Količina", value: "quantity", align: "left" },
    ],
    items_modal_izabrani_tankovi: [],
    pomQuantity: [],
    pomUnitOfMeasureId: 0,
    pomUnitOfMeasureMark: "",
    brojDec: 1,
    brojDecOstatak: 4,
  }),
  watch: {
    articleId: function (val) {
      this.materialFromWarehouseDocumentItemList = [];
      this.items_modal_izabrani_tankovi = [];

      // if (val != undefined && val != 0) this.getAllSifarnik2();
    },
    listaMaterijalaMaka: function (val) {
      console.log(this.izabrani_aditiv);
    },
    documentId: function (val) {
      // watch it

      if (this.articleId != undefined && this.articleId != 0) {
        // this.getAllSifarnik2();
      } else {
        this.items_modal_izabrani_tankovi = [];
        this.materialFromWarehouseDocumentItemList = [];
      }
    },
    operation: function (val) {
      // watch it
    },
    unitOfMeasureId: function (val) {
      // watch it

      if (val !== undefined) {
        this.getUnitOfMeasureId();

        if (this.articleId != undefined && this.articleId != 0)
          this.getAllSifarnik2();
      }
    },
    additiveQuantity: function (val) {
      

      if(val !== undefined && val !== null)
        if(this.items_modal_izabrani_tankovi.length === 1){
          this.items_modal_izabrani_tankovi[0].quantity = Number(val);
          this.items_modal_izabrani_tankovi[0].quantityPom = Number(val);
        }
      
    },
    ID: function (val) {},
    izabrani_aditiv: function (val) {
      this.materialFromWarehouseDocumentItemList = [];
    },
    dodavanje_novog: function (val) {},
    edit: function (val) {},
  },
};
</script>
<style lang="scss" scoped>
table,
th,
td {
  padding-left: 5px;
  padding-right: 5px;
}

div.v-small-dialog__actions {
  display: none !important;
}

div.v-input.v-text-field.v-text-field--single-line.v-input--is-label-active.v-input--is-dirty {
  width: 50% !important;
}

button.v-btn.v-btn--flat.theme--light.primary--text {
  border-radius: inherit;
  color: yellow !important;
}
</style>